import { useRef } from 'react';

let lastId = 0;

/**
 * Prefer useHtmlId.
 * Use with caution, e.g. in legacy class components.
 *
 * @internal
 */
export const generateUniqueHtmlId = (prefix = 'id') => `${prefix}_${lastId++}`;

/**
 * Generate unique but stable HTML id
 *
 * Prefer not using IDs as their uniqueness on the entire page kills component reusability.
 * But if you have to, e.g. to bind a label to an input, use this hook.
 *
 * @example
 * const surnameId = useHtmlId('surname');
 *
 * return <>
 *   <label htmlFor={surnameId}>Surname</label>
 *   <input id='surname' ... />
 * <>;
 */
export function useHtmlId(prefix = 'element'): string {
  const id = useRef<string>();
  if (!id.current) {
    id.current = generateUniqueHtmlId(prefix);
  }
  return id.current;
}
